import React from 'react';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import ConnectionStatusWidgetBody from './body';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    url: <string>
  }
}
*/

export const exportEventName = "connectionStatusExportChart";

const ConnectionStatus = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs({ ...props, className: "dynamic-grid-item" });
  const configBuilder = (_state) => {
    return {
      remoteOptions: getRemoteConfigs(url, ConnectionStatusWidgetBody)
    };
  };

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder, { exportEventName });

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      headerActions={ actions.headerActions }
      footerActions={ actions.footerActions }
      { ...widgetConfig.remoteOptions }
    />
  );
};

export default ConnectionStatus;
